import { jsx as e } from "react/jsx-runtime";
import { useStore as o } from "../store/index.mjs";
import { S3_SHARED_BUCKET_URL as i } from "../constants/s3-bucket-url.mjs";
const f = ({
  affiliateLink: r
}) => {
  const { locale: t } = o(), a = /* @__PURE__ */ e(
    "img",
    {
      alt: "Systeme.io",
      src: `${i}/images/affiliate-badge/badge-${t}.svg`
    }
  );
  return /* @__PURE__ */ e("div", { className: "fixed bottom-1 right-1 z-[3]", children: r ? /* @__PURE__ */ e("a", { "aria-label": "Systeme.io", href: r, target: "_blank", rel: "noopener noreferrer", children: a }) : a });
};
export {
  f as default
};
